module.exports = __webpack_public_path__ + "static/media/login-illustration.a731c78b.png";